module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar-container",
    style: (_vm.avatarStyle)
  }, [_c('popup-maid', {
    attrs: {
      "visible": _vm.showPopup,
      "time": _vm.time,
      "type-cleaning": _vm.typeCleaning,
      "name": (_vm.firstname + " " + _vm.lastname)
    },
    on: {
      "close-popup": _vm.actionAvatar,
      "action-popup": _vm.editMaid
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "avatar-text",
    on: {
      "click": _vm.actionAvatar
    }
  }, [_vm._v(_vm._s(_vm.avatarLetters))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ee66636","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/AvatarProfile.vue
// module id = 756
// module chunks = 108